<template>
  <div class="sy-nav">
    <van-nav-bar
      :title="$route.meta.title"
      left-arrow
      fixed
      :right-text="$t('viewBase.a66')"
      @click-left="onClickLeft"
      @click-right="submit"
    />

    <van-cell-group class="vancellgroup">
      <van-cell is-link :title="$t('viewBase.a67')" class="align">
        <img v-lazy="info.headUrl" class="avatar" alt="">
        <input type="file" class="file" accept="image/*" @change="fileChange">
      </van-cell>
      <van-field
        readonly
        clickable
        :label="$t('viewBase.a29')"
        input-align="right"
        is-link
        class="align"
        :value="info.relationShip"
        :placeholder="$t('viewBase.a28')"
        @click="showPicker = true"
      />
      <van-field v-model="info.name" input-align="right" :label="$t('viewBase.a68')" :placeholder="$t('viewBase.a69')" />
      <van-field
        readonly
        clickable
        :label="$t('viewBase.a79')"
        input-align="right"
        is-link
        class="align"
        :value="genderName"
        :placeholder="$t('viewBase.a71')"
        @click="showGender = true"
      />
      <van-cell is-link :title="$t('viewBase.a80')" class="align" @click="showDate=true">
        {{ info.birthdayShow? dateFormat(info.birthdayShow, 'YYYY-MM-DD'):$t('viewBase.a72') }}
      </van-cell>
      <van-field
        v-model="info.addr"
        :label="$t('viewBase.a78')"
        type="textarea"
        :placeholder="$t('viewBase.a73')"
        rows="1"
        input-align="right"
        autosize
      />
      <van-field v-model="info.phone" type="tel" input-align="right" :label="$t('viewBase.a31')" :placeholder="$t('viewBase.a30')" />
    </van-cell-group>
    <van-popup v-model="showGender" position="bottom">
      <van-picker
        :confirm-button-text="$t('viewBase.a81')"

        :cancel-button-text="$t('viewBase.a2')"
        class="van-picker_relative"
        :visible-item-count="3"
        show-toolbar
        :columns="gender"
        value-key="value"
        @cancel="showGender = false"
        @confirm="onConfirmGender"
      />
    </van-popup>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        :confirm-button-text="$t('viewBase.a81')"

        :cancel-button-text="$t('viewBase.a2')"
        class="van-picker_relative"
        :visible-item-count="3"
        show-toolbar
        :columns="relationshipList"
        value-key="relationship"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="info.birthdayShow"
        :confirm-button-text="$t('viewBase.a81')"
        :cancel-button-text="$t('viewBase.a2')"
        class="van-picker_relative"
        show-toolbar
        type="date"
        :max-date="maxDate"
        :min-date="minDate"
        @cancel="showDate = false"
        @confirm="handleMeasureDateConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { getFamilyRelationshipList, addGroupFamily, EditGroupFamily } from '@/api/family'
import { fetchUserInfo } from '@/api/mine'
import { dateFormat, dateISO, isMobile } from '@/utils/tool'
import { upload } from '@/api/upload.js'
import { getUserGroupId } from '@/utils/auth'
import { setTimeout } from 'timers'

export default {
  data() {
    return {
      listQuery: {
        accountId: ''
      },
      dateFormat,
      dateISO,
      value: '',
      showPicker: false,
      relationshipList: [],
      minDate: new Date(1950, 1, 1),
      maxDate: new Date(),
      showDate: false,
      genderName: '',
      gender: [{ id: 'MAN', value: this.$t('viewBase.a33') }, { id: 'WOMAN', value: this.$t('viewBase.a34') }],
      info: {
        headUrl: '',
        userGroupId: getUserGroupId(),
        relationShip: '',
        name: '',
        birthdayShow: '',
        addr: '',
        gender: '',
        phone: ''
      },
      showNation: false,
      showGender: false
    }
  },
  created() {
    console.log(this.$route.query.peopleAccountId)
    getFamilyRelationshipList().then(response => {
      this.relationshipList = response.data.data
    })
    if (this.$route.query.peopleAccountId > 0) {
      this.listQuery.accountId = this.$route.query.peopleAccountId
      this.$route.meta.title = this.$t('routerBase.a4')
      this.$route.meta.i18n = 'a4'

      this.getPeopleUserInfo()
    } else {
      this.$route.meta.title = this.$t('routerBase.a3')
    }
    // document.title = this.$route.meta.title
  },
  methods: {
    getPeopleUserInfo() {
      fetchUserInfo(this.listQuery).then(res => {
        this.info = res.data.data
        if (res.data.data.birthday) {
          this.info.birthdayShow = new Date(res.data.data.birthday)
        }
        this.$set(this.info, 'relationShip', this.$route.query.peopleRelationship)
        this.genderName = res.data.data.gender === 'MAN' ? this.$t('viewBase.a33') : this.$t('viewBase.a34')
        this.info.groupId = getUserGroupId() || ''
        console.log(this.info)
      })
    },
    onConfirm(value) {
      this.info.relationShip = value.relationship
      this.showPicker = false
    },
    onConfirmGender(value) {
      this.info.gender = value.id
      console.log(this.info.gender)
      this.genderName = value.value
      this.showGender = false
    },
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
        //   Toast('返回')
    },
    // 上传图片
    fileChange(e) {
      if (e.size / 1024 / 1024 > 2) {
        alert('上传图片最大限制2M')
        return false
      }
      var file = e.target.files[0]
      var extension = file.type.split('/')[1]
      upload({
        file,
        extension,
        accountId: this.accountId
      }).then(res => {
        if (res.data.code === 0) {
          this.info.headUrl = res.data.data
        } else {
          this.$toast({
            message: res.Message
          })
        }
      })
    },
    submit: debounce(async function() {
      console.log(0)
      this.info.birthday = ''
      if (!this.info.relationShip) {
        return this.$toast({
          message: this.$t('viewBase.a35'),
          duration: 1500
        })
      }
      if (!this.info.name) {
        return this.$toast({
          message: this.$t('viewBase.a74'),
          duration: 1500
        })
      }
      if (!this.info.gender) {
        return this.$toast({
          message: this.$t('viewBase.a75'),
          duration: 1500
        })
      }
      if (!this.info.birthdayShow) {
        return this.$toast(this.$t('viewBase.a76'))
      }
      if (!isMobile(this.info.phone)) {
        return this.$toast({
          message: this.$t('viewBase.a36'),
          duration: 1500
        })
      }
      this.info.birthday = dateISO(`${dateFormat(this.info.birthdayShow, 'YYYY/MM/DD')} 23:59:59`)
      try {
        if (this.$route.query.peopleAccountId > 0) {
          var { data } = await EditGroupFamily(this.info)
        } else {
          data = await addGroupFamily(this.info)
        }

        if (data) {
          this.$toast.success(this.$t('viewBase.a77'))
          if (this.$store.state.platform === 'ios') {
            window.webkit.messageHandlers.login.postMessage(data.data)
          } else if (this.$store.state.platform === 'android') {
            const givedata = JSON.stringify(data.data)
            window.Android.login(givedata)
          }
          setTimeout(_ => {
            this.$router.go(-1)
          }, 1500)
        }
      } catch (error) {
        console.log('[login error]:', error)
      }
    }, 500, { leading: true }),
    confirmGender(e) {
      if (e === this.$t('viewBase.a33')) {
        this.info.gender = 'MAN'
      } else {
        this.info.gender = 'WOMAN'
      }
      this.showGender = false
    },
    handleMeasureDateConfirm() {
      this.showDate = false
    }
  }
}
</script>

<style scoped lang="scss">
  .van-field__control {
    text-align: right;
  }

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 2px;
    vertical-align: middle;
  }

  .align {
    align-items: center;
    padding-right: 11px;
  }

  .file {
    position: absolute;
    right: -20px;
    width: 80px;
    height: 40px;
    opacity: 0;
    z-index: 100;
  }

  .btn {
    width: 92%;
    margin: 30px 4% 0;
    background: #F99600;
    color: #fff;
  }

  .btn-logout {
    background: #bbb;
    margin: 20px 4%;
  }

  .vancellgroup {
    margin-top: 48px;
  }

</style>

